/**
 * Central configuration system.
 * Exports all configuration schemas, defaults, and utilities.
 */

export * from './types';
export * from './settings/camera';
export { DEFAULT_CAMERA_CONFIG, CAMERA_CONFIG_SCHEMA } from './settings/camera';
export { DEFAULT_BUILDING_CONFIG, BUILDING_CONFIG_SCHEMA } from './settings/buildings';
export type { BuildingConfig } from './settings/buildings';
export { DEFAULT_UNIT_CONFIG, UNIT_CONFIG_SCHEMA } from './settings/units';
export type { UnitConfig } from './settings/units';
export type { CameraConfig } from './settings/camera';
export { getCameraConfig } from './getConfig';
export * from './utils';

/**
 * All configuration schemas combined.
 * This can be used to generate UI components or validate settings.
 */
import { CAMERA_CONFIG_SCHEMA } from './settings/camera';
import { BUILDING_CONFIG_SCHEMA } from './settings/buildings';
import { UNIT_CONFIG_SCHEMA } from './settings/units';

export const ALL_CONFIG_SCHEMAS = {
  camera: CAMERA_CONFIG_SCHEMA,
  buildings: BUILDING_CONFIG_SCHEMA,
  units: UNIT_CONFIG_SCHEMA,
} as const;

/**
 * All default configurations combined.
 */
import { DEFAULT_CAMERA_CONFIG } from './settings/camera';
import { DEFAULT_BUILDING_CONFIG } from './settings/buildings';
import { getDefaultUnitConfig } from './settings/units';

export const ALL_DEFAULT_CONFIGS = {
  camera: DEFAULT_CAMERA_CONFIG,
  buildings: DEFAULT_BUILDING_CONFIG,
  get units() {
    return getDefaultUnitConfig();
  },
} as const;
